angular.
module("dx.webapp.api").
factory("dxApiV1OnlineResources", function apiV1OnlineResourcesService(
	$http
) {
	"use strict";

	function resolve(url, isExternalTool) {
		return $http.post("/api/v1/onlineresources/resolve", {url: url, isExternalTool: !!isExternalTool});
	}

	return {
		resolve: {
			post: resolve,
		},
	};
});
